@let promoList = promoList$();
@let customBadges = customBadges$();

<div class="hmf-px-xs hmf-px-m-s plp-card-container" id="plp-container">
	@if (showSkeletonLoader()) {
		@for (item of loaderDummyArray(); track $index) {
			<shared-totf-components-skeleton-product-card
				class="product-card"
				[compareCheckboxEnabled]="compareCheckboxEnabled()">
			</shared-totf-components-skeleton-product-card>
		}
	} @else {
		@if (displayableProductListData().length > 0) {
			@for (
				plpProduct of displayableProductListData();
				let i = $index;
				track trackDPLD(i, plpProduct)
			) {
				@if (
					isProductVo(plpProduct)
				) {
					<div class="product-card hmf-position-relative">
						<shared-totf-components-product-card
							id="product-card-{{ i }}"
							referrer="{{ productCardReferrer() }}"
							[seoUrl]="
								plpProduct.assetSeoUrl ||
								plpProduct.dsgSeoUrl
							"
							[attributes]="plpProduct.attributes"
							[badge]="plpProduct.badge"
							[customBadge]="
								customBadges[
									plpProduct.parentPartnumber
								]
							"
							[chainAbbr]="chainAbbr()"
							[colors]="plpProduct.skuAttributes?.Color"
							[skuCount]="plpProduct.skuCount"
							[dataEm]="
								'plp_' +
								(i + 1) +
								'_' +
								plpProduct.parentPartnumber +
								(plpProduct.isPinned
									? '_pinned'
									: '')
							"
							[ecode]="plpProduct.parentPartnumber"
							[isComingSoon]="plpProduct.isComingSoon"
							[mapPriceIndicator]="
								plpProduct.mapPriceIndicator
							"
							[priceIndicator]="
								plpProduct.priceIndicator
							"
							[prices]="
								plpProduct.prices | transformPrices
							"
							[productAvailabilityData]="availabilityCollection()
									?.ecodeMessagingMap?.[
									plpProduct.parentPartnumber
								] ?? null
							"
							[productQuickViewEnabled]="
								plpProduct.quickViewEnabled
							"
							[promo]="
								(plpProduct | resolvePromo: promoList)
							"
							[selectedForCompare]="
								compareListEcodes()
									| includes
										: plpProduct.parentPartnumber
							"
							[compareBarProductsCount]="
								compareListEcodes().length
							"
							[selectedStoreName]="selectedStoreInfo()?.name ?? ''
							"
							[title]="plpProduct.name"
							[ratingValue]="
								plpProduct.ratingValue || 0
							"
							[ratingCount]="
								plpProduct.ratingCount || 0
							"
							[availabilityOnProductCardsEnabled]="
								showAvailabilityData()
							"
							[showCustomerRating]="
								plpShowCustomerRating()
							"
							[isLCPImage]="
								i < MAX_NUMBER_ITEMS_PER_ROW
							"
							[isNgOptimizedImageSupported]="true"
							[isAntiClearance]="isAntiClearance()"
							[categoryGroupId]="productListSEOData()?.catgroupId"
							[categoryIdentifier]="productListSEOData()?.identifier"
							[categoryType]="productListSEOData()?.categoryType"
							[compareCheckboxEnabled]="
								compareCheckboxEnabled()
							"
							[moreOptionsQVEnabled]="moreOptionsQVEnabled()"
							[moreOptionsPDPEnabled]="moreOptionsPDPEnabled()"
							[golfCartCheckoutIconEnabled]="golfCartCheckoutIconEnabled()"
							(productCardClick)="
								recordClickEvent(
									$event,
									plpProduct,
									i
								)
							"
							(compareCheckboxClick)="
								handleCompareSelection($event)
							">
						</shared-totf-components-product-card>

						@if (
							chainAbbr() !== 'g3' &&
							plpProduct.badge !== 'CustomizeIt' &&
							plpProduct.badge !==
								'PersonalizedItem'
						) {
							<shared-favorites-components-auth-icon
								class="favorites-icon"
								[ecode]="
									plpProduct.parentPartnumber
								"
								[location]="
									FavoritesLocationEnum.PLP
								"
								[isAuthenticated]="
									isAuthenticated()
								"></shared-favorites-components-auth-icon>
						}
					</div>
				}
				@if (
					featureFlags().showPinnedContent &&
					isPinnedContent(plpProduct)
				) {
					<plp-components-pinned-content
						class="product-card hmf-pl-0 hmf-mb-s"
						id="{{ pinnedOnViewBeacon(plpProduct) ? 'sponsored-pinned-content-' + i : 'pinned-content-' + i }}"
						[attr.data-em]="criteoDataEms()[i] ?? ''"
						[availabilityOnProductCardsEnabled]="
							showAvailabilityData()
						"
						[row]="
							(i / numberOfItemsPerRow() | dcsgMathFloor) + 1
						"
						[column]="(i % numberOfItemsPerRow()) + 1"
						[lazyLoad]="i >= MAX_NUMBER_ITEMS_PER_ROW"
						[imagePagePosition]="
							i >= MAX_NUMBER_ITEMS_PER_ROW
								? IMAGE_PAGE_POSITION_5
								: DEFAULT_IMAGE_PAGE_POSITION
						"
						[pinnedContent]="plpProduct"
						[showCustomerRating]="
							plpShowCustomerRating()
						"
						[isSponsored]="!!pinnedOnViewBeacon(plpProduct)">
					</plp-components-pinned-content>
				}
				@if (
					featureFlags().showPLPSponsoredProducts &&
					isSponsoredProduct(plpProduct) &&
					sortingByValidValues()
				) {

					<div class="hmf-position-relative">
						<shared-totf-components-product-card
							id="sponsored-product-{{ i }}"
							class="product-card criteo-{{
								plpProduct.product?.ID
							}}"
							referrer="{{ productCardReferrer() }}"
							[clickTrackerUrl]="
								plpProduct.click_tracker ?? ''
							"
							[basketChangeBeacon]="
								plpProduct.onBasketChangeBeacon ?? ''
							"
							[seoUrl]="plpProduct.product?.URL"
							[badge]="
								plpProduct.product?.badge"
							[isSponsored]="true"
							[isCriteo]="!!plpProduct.isCriteo"
							[chainAbbr]="chainAbbr()"
							[colors]="plpProduct.product?.Color ?? []"
							[skuCount]="plpProduct.product?.SkuCount ?? 0"
							[dataEm]="criteoDataEms()[i] ?? ''"
							[ecode]="plpProduct.product_id ?? ''"
							[imageUrl]="
								plpProduct.product?.ImageURL ? (plpProduct.product?.ImageURL + 
								'&wid=252&hei=252&qlt=85,0&fmt=jpg&op_sharpen=1') : ''
							"
							[isComingSoon]="!!plpProduct?.isComingSoon"
							[mapPriceIndicator]="
								plpProduct.product?.mapPriceIndicator
							"
							[priceIndicator]="
								plpProduct.product?.priceIndicator ?? null"
							[prices]="
								{
									minofferprice:
										plpProduct.product
											?.minofferprice,
									maxofferprice:
										plpProduct.product
											?.maxofferprice,
									minlistprice:
										plpProduct.product
											?.minlistprice,
									maxlistprice:
										plpProduct.product
											?.maxlistprice
								} | transformPrices
							"
							[selectedForCompare]="
								compareListEcodes()
									| includes
										: plpProduct.product_id
							"
							[compareBarProductsCount]="
								compareListEcodes().length
							"
							[productAvailabilityData]="
								availabilityCollection()
									?.ecodeMessagingMap?.[
									plpProduct.product_id ?? ''
								] ?? null
							"
							[productQuickViewEnabled]="true"
							[selectedStoreName]="
								selectedStoreInfo()?.name ?? ''
							"
							[title]="plpProduct.product?.Name ?? ''"
							[showCustomerRating]="
								plpShowCustomerRating()
							"
							[ratingCount]="plpProduct.product?.ReviewCount || 0"
							[ratingValue]="plpProduct.product?.CustomerRating || 0"
							[isAntiClearance]="isAntiClearance()"
							[categoryGroupId]="
								productListSEOData()?.catgroupId
							"
							[categoryIdentifier]="
								productListSEOData()?.identifier
							"
							[categoryType]="
								productListSEOData()?.categoryType
							"
							(productCardClick)="
								recordClickEvent(
									$event,
									plpProduct,
									i
								)
							"
							[availabilityOnProductCardsEnabled]="
								showAvailabilityData()
							"
							[compareCheckboxEnabled]="
								compareCheckboxEnabled()
							"
							[moreOptionsQVEnabled]="moreOptionsQVEnabled()"
							[moreOptionsPDPEnabled]="moreOptionsPDPEnabled()"
							[golfCartCheckoutIconEnabled]="golfCartCheckoutIconEnabled()"
							(compareCheckboxClick)="
								handleCompareSelection($event)
							">
						</shared-totf-components-product-card>
						@if (chainAbbr() !== 'g3') {
							<shared-favorites-components-auth-icon
								class="favorites-icon"
								[ecode]="plpProduct.product_id ?? ''"
								[location]="FavoritesLocationEnum.PLP"
								[isAuthenticated]="isAuthenticated()"
								[onWishlistBeacon]="
									plpProduct.onWishlistBeacon ?? ''">
							</shared-favorites-components-auth-icon>
						}
					</div>
				}
			}
			@defer (on idle) {
				@if (criteoVideoPlacement(); as videoPlacement) {
					@if (hasCriteoVideo()) {
						<shared-components-criteo-video
							class="criteo-video-player"
							[videoPlacement]="videoPlacement">
						</shared-components-criteo-video>
					}
				}
			} @placeholder {
				<div></div>
			}
		} @else {
			<plp-components-no-filtered-results
        class="hmf-pl-xxs hmf-pt-xxs"></plp-components-no-filtered-results>
		}
	}
@if (displayableProductListData().length > 0) {
	@defer (on idle) {
		@if (featureFlags().plpGoogleAdManagerEnabled) {
			<shared-components-google-ad-manager
				class="ad-manager ad-manager-grid"
				[data]="'grid_banner'"
				[style.--grid-row]="gridBannerRow()"
				[style.--grid-row-mobile]="gridBannerRowMobile()"
				[showSponsoredLabel]="true"
				[enableTooltipSurvey]="
					enableTooltipSurvey()
				">
			</shared-components-google-ad-manager>
		}
	} @placeholder {
		<div></div>
	}
}

@if (pzVisibleBanners().length > 0) {
	@defer (on idle) {
		@for (banner of pzVisibleBanners(); track banner.rowPosition) {
			<plp-components-personalized-banner
				class="pz-personalized-banner-grid-item"
				[class.pz-personalized-banner-grid-item--hidden-desktop]="featureFlags().plpGoogleAdManagerEnabled && banner.rowPosition === gridBannerRow()"
				[class.pz-personalized-banner-grid-item--hidden-mobile]="featureFlags().plpGoogleAdManagerEnabled && banner.rowPosition === gridBannerRowMobile()"
				[style.grid-row-start]="banner.rowPosition"
				[banner]="banner"
				[attr.aria-label]="banner.title">
			</plp-components-personalized-banner>
		}
	} @placeholder {
		<div></div>
	}
}
</div>
